import React from 'react'

export default () => (<div>   <div className="text-center mt-2 footerStyle">
    &copy; {new Date().getFullYear()} toppansecurity.com | All Rights Reserved
</div></div>)